import React, { useEffect } from "react";
import "./privacypolicy.scss";
import { tickIcon } from "../../source";

const termListData = [
  {
    mainTitle: "Privacy & Policy",
    termList: [
      {
        // title: "Eligibility",
        description: [
          "This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in Everest Foods. This policy is not applicable to any information collected offline or via channels other than this website. Our Privacy Policy was created with the help of the Free Privacy Policy Generator.",
        ],
      },
      {
        title: "Consent",
        description: [
          "By using our website, you hereby consent to our Privacy Policy and agree to its terms.",
        ],
      },
      {
        title: "Information we collect",
        description: [
          "The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.",
          "If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.",
          "When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.",
        ],
      },
      {
        title: "How we use your information",
        description: [
          "Provide, operate, and maintain our website",
          "Improve, personalize, and expand our website",
          "Understand and analyze how you use our website",
          "Develop new products, services, features, and functionality",
          "Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes",
          "Send you emails",
          "Find and prevent fraud",
        ],
      },
      {
        title: "Log files",
        description: [
          "Everest Foods follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and are a part of hosting services’ analytics. The information collected by log files includes internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users’ movement on the website, and gathering demographic information.",
        ],
      },
      {
        title: "Cookies and Web Beacons",
        description: [
          "Like any other website, Everest Foods uses ‘cookies’. These cookies are used to store information including visitors’ preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users’ experience by customizing our web page content based on visitors’ browser type and/or other information.",
          "For more general information on cookies, please read “Cookies” article from the Privacy Policy Generator.",
        ],
      },
      {
        title: "Advertising Partners Privacy Policies",
        description: [
          "You may consult this list to find the Privacy Policy for each of the advertising partners of Everest Foods.",
          "Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Everest Foods, which are sent directly to users’ browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.",
          "Note that Everest Foods has no access to or control over these cookies that are used by third-party advertisers.",
        ],
      },
      {
        title: "Third-Party Privacy Policies",
        description: [
          "Everest Foods’s Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt out of certain options.",
          "You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers’ respective websites.",
          "CCPA Privacy Rights (Do Not Sell My Personal Information)",
          "Under the CCPA, among other rights, California consumers have the right to: Request that a business that collects a consumer’s personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.",
          "Request that a business delete any personal data about the consumer that a business has collected.",
          "Request that a business that sells a consumer’s personal data, not sell the consumer’s personal data.",
          "If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.",
        ],
      },
      {
        title: "GDPR Data Protection Rights",
        description: [
          "We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:",
          "The right to access – You have the right to request copies of your personal data. We may charge you a small fee for this service.",
          "The right to rectification – You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.",
          "The right to erasure – You have the right to request that we erase your personal data, under certain conditions.",
          "The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.",
          "The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.",
          "The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.",
          "If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.",
        ],
      },
      {
        title: "Children’s Information",
        description: [
          "Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.",
          "Everest Foods does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.",
        ],
      },
    ],
  },
];

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section className={`privacy_sec1`}>
        <div className="my_container">
          <div className="term_content">
            {/* <p className="notice">Terms & Conditions</p> */}
            <div className="term_content_box">
              {termListData?.map((item, index) => (
                <div className="terms_list_box" key={index}>
                  <p className="notice">{item?.mainTitle}</p>
                  {item?.termList?.map((data, i) => (
                    <div className="term_data_box" key={`terms-${i}`}>
                      <p
                        className="heading"
                        dangerouslySetInnerHTML={{ __html: data?.title }}
                      ></p>
                      <div className="term_points">
                        {data?.description?.map((desc, index) => (
                          <div className="title_flex">
                            <img
                              width={24}
                              height={18}
                              src={tickIcon}
                              alt="tick"
                              className="tick_icon"
                              loading="lazy"
                            />
                            <h3
                              className="term_title"
                              dangerouslySetInnerHTML={{ __html: desc }}
                              key={`description-${index}`}
                            ></h3>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
              {/* <div className="checkbox_wrap">
                     <h5 className="heading">Consent & Agreement</h5>
                     <div className="consent_checks">
                       <div className="form-group form-check">
                         <input
                           type="checkbox"
                           className="form-check-input"
                           id="participationConsent"
                           name="participationConsent"
                           checked={termsData.participationConsent}
                           onChange={handleTermsChange}
                         />
                         <label
                           className="form-check-label"
                           htmlFor="participationConsent"
                         >
                           I agree to participate in Everest Taste Masters and create
                           content using Everest Spices.
                         </label>
                       </div>
                       {termsErrors.participationConsent && (
                         <div className="error_message" style={{ color: "red" }}>
                           {termsErrors.participationConsent}
                         </div>
                       )}
                       <div className="form-group form-check">
                         <input
                           type="checkbox"
                           className="form-check-input"
                           id="termsConsent"
                           name="termsConsent"
                           checked={termsData.termsConsent}
                           onChange={handleTermsChange}
                         />
                         <label className="form-check-label" htmlFor="termsConsent">
                           I understand the terms & conditions, and I consent to
                           providing the above information for the purpose of this
                           program.
                         </label>
                       </div>
                       {termsErrors.termsConsent && (
                         <div className="error_message" style={{ color: "red" }}>
                           {termsErrors.termsConsent}
                         </div>
                       )}
                     </div>
                   </div> */}
              {/* <div className="cta_wrapper">
                     <button
                       className="common_cta"
                       onClick={handleTermsSubmit}
                       disabled={isSubmitting}
                     >
                       {isSubmitting ? "Submitting..." : "Submit"}
                     </button>
                   </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
